import { createElement } from 'react';
import './index.scss';
import MenuListItem from "./menu-list-item";
const MenuList = ({ dataList, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "menu-list__panel", ..._otherProps },
        createElement("div", { className: "menu-list__panel__item-list" }, dataList.map((item, index) => {
            return createElement(MenuListItem, { key: index, title: item.title, iconUrl: item.iconUrl, handleClick: item.handleClick });
        }))));
};
MenuList.displayName = 'MenuList';
export default MenuList;
